// How long is left of the current day, as the storefront countdown copy reads it.
export const getRemainingTime = (): string => {
  const now: Date = new Date()
  const endOfDay: Date = new Date()
  endOfDay.setHours(23, 59, 59, 999)

  const diffMs: number = endOfDay.getTime() - now.getTime()
  const hours: number = Math.floor(diffMs / (1000 * 60 * 60))
  const minutes: number = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60))

  return `${hours} hr ${minutes} min`
}
